export default {
    notFoundRoute: 'Route not found',
    wrongTemplatePage: 'Route with wrong dynamic page template',
};
